<template>
  <div class="widget w-estimates-ratios-widget" :class="['font-size-' + fontSize, { bold: isFontBold }]">
    <c-widget-header printView :tradeButtonsSymbol="ric" :wid="wid" @keydown.native.tab="tabToFirstCell">
      <c-incremental-search
        slot="left"
        :ric="ric"
        @error="onSymbolSearchError"
        @change-ric="onSetRIC"
        :instrumentTypes="['STO']"
      />
      <slot name="buttons" slot="buttons" />
    </c-widget-header>

    <w-body
      v-if="ric"
      :wid="wid"
      :ric="ric"
      :selection="$store.state.widget[wid].dataSelection"
      :locale="locale"
      :fontSize="fontSize"
      :isFontBold="isFontBold"
      @selection-changed="onSelectionChanged"
    />
    <v-alert v-else align="center" class="m-2" show variant="light">{{ i18n('nosymbol', 'globalMessages') }}</v-alert>
    <b-toaster :name="notifierId"></b-toaster>
  </div>
</template>

<script>
import CWidgetHeader from '@custom/widgetContainer/CWidgetHeader';
import CIncrementalSearch from '@custom/CIncrementalSearch';
import WBody from '@widgets/WEstimatesRatiosWidget/WBody';
import widgetCommons from '@mixins/widgetCommons';

export default {
  name: 'w-estimates-ratios-widget',
  mixins: [widgetCommons],
  components: {
    CWidgetHeader,
    CIncrementalSearch,
    WBody
  },
  props: {
    wid: {
      type: String,
      required: true
    }
  },
  computed: {
    ric() {
      return this.widgetStore.ric;
    },
    locale() {
      return this.$store.state.applicationSettings.general.settings.applicationLanguage;
    }
  },
  methods: {
    onSetRIC(value) {
      this.$store.commit(`widget/${this.wid}/RIC_CHANGED`, value || '');
      this.sendLinkUpdate(value);
    },
    onSelectionChanged({ tableName, label }) {
      this.$store.commit(`widget/${this.wid}/SELECTION_CHANGED`, { key: tableName, value: label });
    },
    tabToFirstCell(event) {
      if (event.target.classList.contains('close-button') && !event.shiftKey) {
        let cellElement = this.$el.querySelector('table td');
        if (cellElement) cellElement.focus();
        event.preventDefault();
      }
    }
  }
};
</script>

<style lang="scss">
@import '~@/styles/widgets/estimates-ratios-widget';
</style>
